module.exports = __webpack_public_path__ + "img/s1.7760c6d6.png";